<app-header *ngIf="!embutido"></app-header>

<div [class.min-h-screen]="!embutido" [class.tema-claro]="!embutido">
  <div [ngClass]="embutido ? '' : 'max-w-5xl mx-auto p-6'">

    <div *ngIf="!embutido" class="mb-6 flex items-center gap-2 text-xs" style="color: var(--tx-2)">
      <a routerLink="/home" class="hover:underline" style="color: var(--brand-primary)">Início</a>
      <span>/</span>
      <a routerLink="/lancamentos-financeiros" class="hover:underline" style="color: var(--brand-primary)">Lançamentos Financeiros</a>
      <span>/</span>
      <span class="font-semibold" style="color: var(--tx)">Pagamento Avulso</span>
    </div>

    <!-- sem overflow-hidden: ele recortava os dropdowns absolutos de paciente e de terminal.
         O arredondamento do topo vem do próprio header. -->
    <div class="bg-white max-w-2xl mx-auto"
         style="border-radius: 18px; border: 1px solid #EFE9DD; box-shadow: 0 24px 60px -20px rgba(16,24,32,.5)">

      <div class="modal-v2-topo">
        <div class="flex-1 min-w-0">
          <p class="modal-v2-eyebrow">Pagamentos</p>
          <h3 class="modal-v2-titulo">Pagamento avulso</h3>
          <p class="modal-v2-sub">Cobre na maquininha, no Pix ou em dinheiro, sem abrir atendimento.</p>
        </div>
        <button type="button" (click)="voltar()" title="Fechar" class="modal-v2-fechar">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
               stroke-width="2" stroke="currentColor" class="size-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <div class="px-7 pb-7 space-y-5">

        <div>
          <label class="text-xs font-semibold mb-2 block" style="color: var(--tx)">Paciente</label>

          <div *ngIf="!paciente" class="relative">
            <div class="relative">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="2" stroke="currentColor" class="campo-busca-icone size-4">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"/>
        </svg>
              <input type="text"
                     [(ngModel)]="termoBusca"
                     (ngModelChange)="onTermoBuscaChange()"
                     placeholder="Digite nome ou CPF (mín. 3 caracteres)"
                     class="campo-busca"/>
              <div class="campo-busca-acao">
                <div *ngIf="isBuscando" class="animate-spin rounded-full h-4 w-4 border-b-2" style="border-color: var(--brand-primary)"></div>
                <button *ngIf="!isBuscando && termoBusca"
                        type="button"
                        (click)="termoBusca = ''; resultadosBusca = []"
                        title="Limpar busca"
                        style="color: var(--tx-2)">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                       stroke-width="2" stroke="currentColor" class="size-4">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
                  </svg>
                </button>
              </div>
            </div>
            <div *ngIf="resultadosBusca.length > 0"
                 class="absolute left-0 right-0 z-10 mt-1 rounded-lg shadow-lg overflow-auto bg-white"
                 style="border: 1px solid var(--flua-borda); max-height: 200px">
              <button *ngFor="let p of resultadosBusca"
                      type="button"
                      (click)="selecionarPaciente(p)"
                      class="w-full text-left px-3 py-2 text-xs hover:bg-gray-50"
                      style="border-bottom: 1px solid #F4F1EA; color: var(--tx)">
                <div class="font-semibold">{{ p.nmPessoaFisica }}</div>
                <div class="text-[11px]" style="color: var(--tx-2)">
                  Código: {{ p.cdPessoaFisica }}
                  <span *ngIf="p.nrCpf"> — CPF: {{ p.nrCpf }}</span>
                </div>
              </button>
            </div>
          </div>

          <div *ngIf="paciente" class="rounded-lg overflow-hidden"
               style="background-color: var(--flua-rodape); border: 1px solid var(--flua-borda)">

            <div class="flex items-start justify-between gap-3 px-3 py-2.5">
              <div class="min-w-0">
                <div class="text-sm font-semibold truncate" style="color: var(--tx)">{{ paciente.nmPessoaFisica }}</div>
                <div class="flex flex-wrap items-center gap-x-3 gap-y-0.5 mt-0.5 text-[11px]" style="color: var(--tx-2)">
                  <span>Código: <span class="font-medium" style="color: var(--tx)">{{ paciente.cdPessoaFisica }}</span></span>
                  <span *ngIf="paciente.nrCpf">CPF: <span class="font-medium" style="color: var(--tx)">{{ formatarCpf(paciente.nrCpf) }}</span></span>
                </div>
              </div>
              <div class="flex items-center gap-2 shrink-0">
                <button type="button" (click)="abrirModalResponsavel()"
                        class="px-2.5 py-1 rounded-md text-[11px] font-semibold transition-colors"
                        [style.border]="respLegalSalvo ? '1px solid #b7e0cb' : '1.5px dashed var(--brand-primary)'"
                        [style.color]="respLegalSalvo ? '#1f6f43' : 'var(--brand-primary)'"
                        [style.background-color]="respLegalSalvo ? '#eefaf3' : 'transparent'">
                  {{ respLegalSalvo ? 'Editar resp.' : 'Vincular resp.' }}
                </button>
                <button type="button" (click)="trocarPaciente()"
                        [disabled]="estado === 'enviando' || estado === 'aguardando'"
                        class="text-xs font-semibold" style="color: var(--brand-primary)"
                        [style.opacity]="estado === 'enviando' || estado === 'aguardando' ? 0.5 : 1"
                        [style.cursor]="estado === 'enviando' || estado === 'aguardando' ? 'not-allowed' : 'pointer'">
                  Trocar
                </button>
              </div>
            </div>

            <!-- Responsável financeiro: linha de dados quando vinculado, convite quando não. -->
            <div class="flex items-center justify-between gap-3 px-3 py-2"
                 style="border-top: 1px dashed var(--flua-borda)"
                 [style.background-color]="respLegalSalvo ? '#eefaf3' : 'transparent'">
              <div class="flex items-center gap-2 min-w-0">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.6"
                     class="size-4 shrink-0" [attr.stroke]="respLegalSalvo ? '#1f6f43' : '#8796A1'">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
                </svg>
                <div class="min-w-0">
                  <div class="text-[10px] font-semibold uppercase" style="color: var(--tx-3); letter-spacing: .05em">
                    Responsável financeiro
                  </div>
                  <div *ngIf="respLegalSalvo && respLegal" class="text-xs truncate" style="color: #1f6f43">
                    <span class="font-semibold">{{ respLegal.nmContato }}</span>
                    <span class="mx-1" style="color: #9ec9b3">•</span>
                    <span>CPF: {{ formatarCpf(respLegal.nrCpf) }}</span>
                  </div>
                  <div *ngIf="!respLegalSalvo" class="text-xs" style="color: var(--tx-3)">
                    Nenhum vinculado
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="paciente" class="space-y-4">

          <div class="rounded-lg p-4 text-center" style="background-color: var(--flua-rodape); border: 1px solid var(--flua-borda)">
            <p class="text-xs mb-1" style="color: var(--tx-2)">Valor a cobrar</p>
            <div class="flex items-center justify-center gap-1">
              <span class="text-lg font-bold" style="color: var(--brand-primary)">R$</span>
              <input type="number" step="0.01" min="0.01"
                     [(ngModel)]="valor"
                     (ngModelChange)="onValorChange()"
                     placeholder="0,00"
                     class="text-2xl font-bold text-center border-b-2 bg-transparent outline-none"
                     style="color: var(--brand-primary); border-color: var(--flua-borda); width: 200px"
                     (focus)="$any($event.target).select()"/>
            </div>
          </div>

          <div>
            <label class="text-xs font-semibold mb-2 block" style="color: var(--tx)">Forma de Pagamento</label>
            <div class="flex gap-2">
              <button type="button" (click)="selecionarMetodo(1)"
                      class="flex-1 py-2 rounded-lg text-xs font-semibold text-center opcao-v2"
                      [class.ativa]="metodo === 1">
                Crédito
              </button>
              <button type="button" (click)="selecionarMetodo(2)"
                      class="flex-1 py-2 rounded-lg text-xs font-semibold text-center opcao-v2"
                      [class.ativa]="metodo === 2">
                Débito
              </button>
              <button type="button" (click)="selecionarMetodo(3)"
                      class="flex-1 py-2 rounded-lg text-xs font-semibold text-center opcao-v2"
                      [class.ativa]="metodo === 3">
                Pix
              </button>
              <button *ngIf="!semCaixa" type="button" (click)="selecionarMetodo(4)"
                      class="flex-1 py-2 rounded-lg text-xs font-semibold text-center opcao-v2"
                      [class.ativa]="metodo === 4">
                Dinheiro
              </button>
            </div>
            <p *ngIf="semCaixa" id="aviso-sem-caixa" class="mt-2 text-xs font-normal" style="color: #92400e">
              Sem caixa vinculado nesta unidade: só cartão e Pix.
            </p>
          </div>

          <div *ngIf="metodo === 1">
            <label class="text-xs font-semibold mb-2 block" style="color: var(--tx)">Parcelas</label>
            <div class="grid grid-cols-6 gap-1">
              <button type="button" *ngFor="let p of opcoesParcelas" (click)="parcelas = p"
                      class="py-1.5 rounded text-xs font-semibold text-center opcao-v2"
                      [class.ativa]="parcelas === p">
                {{ p }}x
              </button>
            </div>
            <p *ngIf="parcelas > 1" class="text-[10px] mt-1" style="color: var(--tx-2)">
              {{ parcelas }}x de {{ brl((valor || 0) / parcelas) }}
            </p>
            <p *ngIf="opcoesParcelas.length === 1" class="text-[10px] mt-1" style="color: var(--tx-2)">
              Parcelamento mínimo: {{ brl(parcelaMinimaAtual) }} por parcela
            </p>
          </div>

          <div *ngIf="metodo !== 4">
            <label class="text-xs font-semibold mb-2 block" style="color: var(--tx)">Terminal (Maquineta)</label>
            <div class="flex gap-2 mb-2">
              <button type="button" (click)="selecionarTerminalTipo('V240mPlus')" class="px-3 py-1.5 rounded text-xs font-semibold opcao-v2"
                      [class.ativa]="maquinetaTerminalTipo === 'V240mPlus'">
                V240mPlus
              </button>
              <button type="button" (click)="selecionarTerminalTipo('P400Plus')" class="px-3 py-1.5 rounded text-xs font-semibold opcao-v2"
                      [class.ativa]="maquinetaTerminalTipo === 'P400Plus'">
                P400Plus
              </button>
              <button type="button" (click)="selecionarTerminalTipo('S1F2')" class="px-3 py-1.5 rounded text-xs font-semibold opcao-v2"
                      [class.ativa]="maquinetaTerminalTipo === 'S1F2'">
                S1F2
              </button>
            </div>
            <div class="relative">
              <div class="flex items-center rounded-lg border overflow-hidden" style="border-color: var(--flua-borda)">
                <span class="px-2 py-2 text-xs bg-gray-50" style="color: var(--tx-2); border-right: 1px solid var(--flua-borda)">{{ maquinetaTerminalTipo }}-</span>
                <input type="text" [(ngModel)]="maquinetaTerminalNumero" (input)="filtrarTerminais()"
                       (focus)="filtrarTerminais()" placeholder="Digite os últimos dígitos..." class="flex-1 text-xs px-2 py-2"
                       style="outline: none; color: var(--tx)"/>
              </div>
              <div *ngIf="showTerminalDropdown"
                   class="absolute z-10 left-0 right-0 mt-1 rounded-lg shadow-lg overflow-hidden"
                   style="background-color: var(--cartao); border: 1px solid var(--flua-borda); max-height: 180px; overflow-y: auto">
                <div *ngFor="let t of maquinetaTerminaisFiltrados" (mousedown)="selecionarTerminal(t)"
                     class="px-3 py-2 text-xs cursor-pointer hover:bg-gray-100 flex justify-between" style="color: var(--tx)">
                  <span>{{ t.tipo }}-<strong>{{ t.numero }}</strong></span>
                  <span class="text-[10px]" style="color: var(--tx-2)">{{ t.loja }}</span>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="metodo === 4" class="space-y-3">

            <div>
              <label class="text-xs font-semibold mb-2 block" style="color: var(--tx)">Caixa</label>
              <select [(ngModel)]="caixaSelecionada"
                      class="w-full px-3 py-2 text-sm rounded-lg"
                      style="border: 1px solid var(--flua-borda); color: var(--tx)">
                <option *ngFor="let c of caixas" [ngValue]="c">{{ c.name }} — {{ c.establishmentName }}</option>
              </select>
            </div>

            <div *ngIf="caixaSelecionada && caixaSelecionada.balanceForToday"
                 class="rounded-lg px-3 py-2 text-xs flex items-center gap-2"
                 style="background-color: #f0fdf4; border: 1px solid #bbf7d0; color: #166534">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#00AC70" class="size-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/>
              </svg>
              Saldo de hoje aberto (seq {{ caixaSelecionada.balanceSequence }}).
            </div>

            <div *ngIf="caixaSelecionada && !caixaSelecionada.balanceForToday"
                 class="rounded-lg px-3 py-3 text-xs space-y-2"
                 style="background-color: #fffbeb; border: 1px solid #fde68a; color: #92400e">
              <p class="flex items-center gap-1.5">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#d97706" class="size-4">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/>
                </svg>
                Este caixa não tem saldo aberto para hoje.
              </p>
              <button type="button" (click)="abrirSaldoHoje()" [disabled]="isAbrindoSaldo"
                      class="px-3 py-1.5 rounded text-xs font-semibold text-white"
                      [style.backgroundColor]="isAbrindoSaldo ? '#D6CFC2' : 'var(--brand-primary)'">
                {{ isAbrindoSaldo ? 'Abrindo saldo...' : 'Abrir Saldo de Hoje' }}
              </button>
            </div>

            <div *ngIf="saldoAbertoFeedback" class="rounded-lg px-3 py-2 text-xs"
                 style="background-color: #eff6ff; border: 1px solid #bfdbfe; color: #1e40af">
              {{ saldoAbertoFeedback }}
            </div>

            <div>
              <label class="text-xs font-semibold mb-2 block" style="color: var(--tx)">Observação (opcional)</label>
              <input type="text" maxlength="200" [(ngModel)]="observacao"
                     placeholder="Ex.: Pagamento consulta dermatologia"
                     class="w-full px-3 py-2 text-sm rounded-lg"
                     style="border: 1px solid var(--flua-borda); color: var(--tx)"/>
            </div>

            <div *ngIf="precisaSangria" class="rounded-lg px-3 py-2 text-xs flex items-start gap-2"
                 style="background-color: #fffbeb; border: 1px solid #fde68a; color: #92400e">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#d97706" class="size-4 flex-shrink-0 mt-0.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/>
              </svg>
              <div>
                <strong>Saldo do caixa ultrapassará R$ 1.000</strong> após este recebimento
                ({{ brl(saldoCaixaProjetado) }}). Realize uma <strong>sangria</strong> em seguida —
                <a routerLink="/lancamentos-financeiros/sangria" class="underline font-semibold">ir para Sangria</a>.
              </div>
            </div>

            <div *ngIf="erro" class="rounded-lg px-3 py-2 text-xs" style="background-color: #fef2f2; border: 1px solid #fecaca; color: #991b1b">
              {{ erro }}
            </div>
          </div>

          <button *ngIf="metodo !== 4" type="button" (click)="cobrar()" [disabled]="!podeCobrar"
                  class="w-full py-2.5 rounded-lg text-sm font-semibold text-white flex items-center justify-center gap-1.5"
                  [style.backgroundColor]="!podeCobrar ? '#D6CFC2' : 'var(--brand-primary)'"
                  [style.cursor]="!podeCobrar ? 'not-allowed' : 'pointer'">
            <div *ngIf="estado === 'enviando'" class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
            {{ estado === 'enviando' ? 'Enviando...' : 'Cobrar' }}
          </button>

          <button *ngIf="metodo === 4" type="button" (click)="pagarEspecie()" [disabled]="!especieFormValido() || isSubmittingCaixa"
                  class="w-full py-2.5 rounded-lg text-sm font-semibold text-white flex items-center justify-center gap-1.5"
                  [style.backgroundColor]="!especieFormValido() || isSubmittingCaixa ? '#D6CFC2' : 'var(--brand-primary)'"
                  [style.cursor]="!especieFormValido() || isSubmittingCaixa ? 'not-allowed' : 'pointer'">
            <div *ngIf="isSubmittingCaixa" class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
            {{ isSubmittingCaixa ? 'Registrando...' : 'Registrar Pagamento' }}
          </button>
        </div>

        <div *ngIf="estado !== 'ocioso'">

          <div *ngIf="estado === 'enviando'" class="rounded-lg px-4 py-3 text-center text-xs" style="background-color: var(--flua-rodape); border: 1px solid var(--flua-borda); color: var(--tx-2)">
            Enviando para o terminal...
          </div>

          <div *ngIf="estado === 'aguardando'" class="rounded-lg px-4 py-3 flex items-center gap-2 text-xs" style="background-color: var(--flua-rodape); border: 1px solid var(--flua-borda); color: var(--tx)">
            <div class="animate-spin rounded-full h-4 w-4 border-b-2" style="border-color: var(--brand-primary)"></div>
            <span>Aguardando o terminal — peça ao paciente para inserir ou aproximar o cartão.</span>
          </div>

          <div *ngIf="estado === 'confirmado'" class="rounded-lg px-4 py-3 text-xs flex items-center justify-between gap-3 flex-wrap"
               style="background-color: #dcfce7; border: 1px solid #bbf7d0; color: #00AC70">
            <p class="font-semibold">{{ mensagem || 'Pagamento confirmado.' }}</p>

            <button *ngIf="podeImprimirComprovante" type="button" (click)="imprimirComprovante()" [disabled]="isImprimindoComprovante"
                    class="px-3 py-1.5 rounded text-xs font-semibold text-white whitespace-nowrap flex-shrink-0"
                    style="background-color: #00AC70"
                    [style.opacity]="isImprimindoComprovante ? 0.6 : 1"
                    [style.cursor]="isImprimindoComprovante ? 'not-allowed' : 'pointer'">
              {{ isImprimindoComprovante ? 'Gerando...' : 'Imprimir comprovante' }}
            </button>

            <p *ngIf="isLocalizandoAdiantamento && !metodoEspecie" class="mt-2 font-normal flex items-center gap-1.5" style="color: var(--tx-2)">
              <span class="animate-spin rounded-full h-3 w-3 border-b-2" style="border-color: #00AC70"></span>
              Localizando o comprovante deste pagamento...
            </p>

            <p *ngIf="!isLocalizandoAdiantamento && !podeImprimirComprovante && !metodoEspecie" class="mt-2 font-normal" style="color: #92400e">
              Não foi possível localizar o número do adiantamento deste pagamento — o comprovante não pode ser emitido. Confira a lista de adiantamentos abaixo.
            </p>

            <p *ngIf="comprovanteErro" class="mt-2 font-normal" style="color: #991b1b">{{ comprovanteErro }}</p>
          </div>

          <div *ngIf="estado === 'erro'" class="rounded-lg px-4 py-3 text-xs" style="background-color: #fef2f2; border: 1px solid #fecaca; color: #991b1b">
            {{ erro || mensagem || 'Não foi possível concluir o pagamento.' }}
          </div>

          <div *ngIf="estado === 'sem-confirmacao'" class="rounded-lg px-4 py-3 text-xs space-y-2" style="background-color: #fffbeb; border: 1px solid #fde68a; color: #92400e">
            <p>O terminal não respondeu. Isso não quer dizer que o pagamento falhou.</p>
            <p *ngIf="mensagem">{{ mensagem }}</p>
            <p *ngIf="erro">{{ erro }}</p>
            <button *ngIf="podeConferir" type="button" (click)="conferirPagamento()" [disabled]="isConferindo"
                    class="px-3 py-1.5 rounded text-xs font-semibold text-white"
                    style="background-color: #b45309"
                    [style.opacity]="isConferindo ? 0.6 : 1">
              {{ isConferindo ? 'Conferindo...' : 'Conferir pagamento' }}
            </button>
            <p *ngIf="!podeConferir">
              Não é possível conferir automaticamente esta cobrança. Confira no terminal e na lista de
              adiantamentos abaixo antes de cobrar de novo.
            </p>
          </div>

        </div>


      </div>
    </div>

    <div *ngIf="paciente" class="bg-white rounded-2xl shadow-sm mt-6" style="border: 1px solid var(--flua-borda)">

      <div class="px-6 py-4 flex items-end justify-between gap-4 flex-wrap"
           style="border-bottom: 1px solid #eef0f4">
        <div>
          <h2 class="text-sm font-semibold" style="color: var(--tx)">Adiantamentos do paciente</h2>
          <p class="text-[11px] mt-0.5" style="color: var(--tx-2)">Últimos 180 dias</p>
        </div>
        <div *ngIf="adiantamentos.length > 0" class="text-right">
          <p class="text-[10px] font-semibold uppercase tracking-wide" style="color: var(--tx-2)">Saldo disponível</p>
          <p class="text-xl font-bold tabular-nums leading-tight"
             [style.color]="totalDisponivel > 0 ? '#166534' : '#9AA6AF'">{{ brl(totalDisponivel) }}</p>
          <p class="text-[11px]" style="color: var(--tx-2)">
            em {{ adiantamentos.length }} {{ adiantamentos.length === 1 ? 'lançamento' : 'lançamentos' }}
          </p>
        </div>
      </div>

      <div class="px-6 py-4">

        <div *ngIf="erroAdiantamentos" class="rounded-lg px-3 py-2 text-xs mb-3"
             style="background-color: #fef2f2; border: 1px solid #fecaca; color: #991b1b">
          {{ erroAdiantamentos }}
        </div>

        <div *ngIf="!erroAdiantamentos && adiantamentos.length === 0"
             class="rounded-lg px-4 py-6 text-xs text-center"
             style="background-color: var(--flua-rodape); border: 1px dashed var(--flua-borda); color: var(--tx-2)">
          Nenhum adiantamento nos últimos 180 dias.
        </div>

        <div *ngIf="adiantamentos.length > 0" class="rounded-xl overflow-hidden" style="border: 1px solid #eef0f4">
          <div *ngFor="let a of adiantamentosPagina; let primeiro = first; trackBy: trackAdiantamento"
               class="px-4 py-3"
               [style.borderTop]="primeiro ? 'none' : '1px solid #eef0f4'"
               [style.backgroundColor]="estaEstornado(a) ? '#fffbfb' : 'white'">

            <div class="flex items-start justify-between gap-4">
              <div class="min-w-0">
                <div class="flex items-center gap-2 flex-wrap">
                  <span class="text-lg font-bold tabular-nums leading-none"
                        [style.color]="saldoExibido(a) > 0 && !foiTransferido(a) ? '#166534' : '#9AA6AF'">
                    {{ brl(saldoExibido(a)) }}
                  </span>
                  <span class="px-2 py-0.5 rounded-full text-[10px] font-semibold"
                        [style.backgroundColor]="situacaoAdiantamento(a).fundo"
                        [style.color]="situacaoAdiantamento(a).cor">
                    {{ situacaoAdiantamento(a).texto }}
                  </span>
                  <span *ngIf="recebidoPorTransferencia(a)" class="px-2 py-0.5 rounded-full text-[10px] font-semibold"
                        style="background-color: #eef2ff; color: #3730a3">
                    Recebido
                  </span>
                </div>

                <div class="text-[11px] mt-1.5 flex items-center gap-1.5 flex-wrap" style="color: var(--tx-2)">
                  <span class="tabular-nums">{{ a.dtAdiantamento | date:'dd/MM/yyyy HH:mm' }}</span>
                  <span style="color: #E5DFD4">|</span>
                  <span>{{ origemDoAdiantamento(a) }}</span>
                  <span style="color: #E5DFD4">|</span>
                  <span class="tabular-nums">nº {{ a.nrAdiantamento }}</span>
                  <span *ngIf="a.vlAdiantamento !== saldoExibido(a)" style="color: #E5DFD4">|</span>
                  <span *ngIf="a.vlAdiantamento !== saldoExibido(a)" class="tabular-nums">
                    pago {{ brl(a.vlAdiantamento) }}
                  </span>
                </div>

                <div *ngIf="foiTransferido(a) && a.nmPessoaAdiant" class="text-[11px] mt-1 flex items-start gap-1"
                     style="color: #3730a3">
                  <span class="font-semibold whitespace-nowrap">Transferido para</span>
                  <span class="break-words">{{ identificacao(a.nmPessoaAdiant, a.nrCpfPessoaAdiant) }}</span>
                </div>

                <div *ngIf="recebidoPorTransferencia(a)" class="text-[11px] mt-1 flex items-start gap-1"
                     style="color: #3730a3">
                  <span class="font-semibold whitespace-nowrap">Recebido de</span>
                  <span class="break-words">{{ identificacao(a.nmPessoaFisica, a.nrCpfPessoaFisica) }}</span>
                </div>
              </div>

              <div class="flex items-center gap-1.5 flex-shrink-0">
                <button *ngIf="!estaEstornado(a) && !recebidoPorTransferencia(a)" type="button" (click)="reimprimir(a)" [disabled]="isReimprimindo"
                        class="px-2.5 py-1 rounded-lg text-[11px] font-semibold"
                        style="border: 1px solid var(--flua-borda); color: var(--tx-2); background-color: var(--cartao)"
                        [style.opacity]="isReimprimindo && reimprimindoAlvo !== a.nrAdiantamento ? 0.5 : 1"
                        [style.cursor]="isReimprimindo ? 'not-allowed' : 'pointer'">
                  {{ isReimprimindo && reimprimindoAlvo === a.nrAdiantamento ? 'Emitindo...' : '2ª via' }}
                </button>

                <button *ngIf="temTermoParaConsultar(a)" type="button" (click)="abrirTermo(a)"
                        [disabled]="isBuscandoTermo"
                        class="px-2.5 py-1 rounded-lg text-[11px] font-semibold"
                        style="border: 1px solid #c7d2fe; background-color: #eef2ff; color: #3730a3"
                        [style.opacity]="isBuscandoTermo && buscandoTermoAlvo !== a.nrAdiantamento ? 0.5 : 1"
                        [style.cursor]="isBuscandoTermo ? 'not-allowed' : 'pointer'">
                  {{ isBuscandoTermo && buscandoTermoAlvo === a.nrAdiantamento ? 'Buscando...' : 'Termo' }}
                </button>

                <button *ngIf="podeTransferir(a)" type="button" (click)="abrirTransferencia(a)"
                        class="px-2.5 py-1 rounded-lg text-[11px] font-semibold"
                        style="border: 1px solid #c7d2fe; background-color: #eef2ff; color: #3730a3">
                  Transferir
                </button>

                <button *ngIf="isSupervisor && podeEstornar(a)" type="button" (click)="abrirConfirmEstorno(a)"
                        class="px-2.5 py-1 rounded-lg text-[11px] font-semibold"
                        style="background-color: #fef2f2; color: #991b1b; border: 1px solid #fecaca">
                  Estornar
                </button>
              </div>
            </div>

            <p *ngIf="erroTermoConsulta && erroTermoAlvo === a.nrAdiantamento" class="text-[11px] mt-1"
               style="color: #991b1b">
              {{ erroTermoConsulta }}
            </p>

            <p *ngIf="a.dsObservacao" class="text-[11px] mt-2 pl-2.5 leading-snug"
               [style.color]="estaEstornado(a) ? '#991b1b' : '#4A5D6B'"
               [style.borderLeft]="'2px solid ' + (estaEstornado(a) ? '#fecaca' : '#E5DFD4')">
              {{ a.dsObservacao }}
            </p>
          </div>
        </div>

        <div *ngIf="totalPaginasAdiantamentos > 1" class="flex items-center justify-between gap-3 mt-3 flex-wrap">
          <span class="text-[11px]" style="color: var(--tx-2)">
            Página {{ paginaAdiantamentos }} de {{ totalPaginasAdiantamentos }}
          </span>
          <div class="flex items-center gap-1.5">
            <button type="button" (click)="irParaPagina(paginaAdiantamentos - 1)"
                    [disabled]="paginaAdiantamentos === 1"
                    class="px-2.5 py-1 rounded-lg text-[11px] font-semibold"
                    style="border: 1px solid var(--flua-borda); color: var(--tx-2); background-color: var(--cartao)"
                    [style.opacity]="paginaAdiantamentos === 1 ? 0.4 : 1"
                    [style.cursor]="paginaAdiantamentos === 1 ? 'not-allowed' : 'pointer'">
              Anterior
            </button>
            <button type="button" (click)="irParaPagina(paginaAdiantamentos + 1)"
                    [disabled]="paginaAdiantamentos === totalPaginasAdiantamentos"
                    class="px-2.5 py-1 rounded-lg text-[11px] font-semibold"
                    style="border: 1px solid var(--flua-borda); color: var(--tx-2); background-color: var(--cartao)"
                    [style.opacity]="paginaAdiantamentos === totalPaginasAdiantamentos ? 0.4 : 1"
                    [style.cursor]="paginaAdiantamentos === totalPaginasAdiantamentos ? 'not-allowed' : 'pointer'">
              Próxima
            </button>
          </div>
        </div>

        <p *ngIf="erroReimpressao" class="mt-2 text-xs" style="color: #991b1b">{{ erroReimpressao }}</p>

          <div *ngIf="ultimoComprovanteEstorno" class="mt-2 rounded-lg px-3 py-2 text-xs flex items-center justify-between gap-2 flex-wrap"
               style="background-color: #fef2f2; border: 1px solid #fecaca; color: #991b1b">
            <span>Estorno de {{ brl(ultimoComprovanteEstorno.valor) }} realizado com sucesso.</span>
            <div class="flex items-center gap-2">
              <button type="button" (click)="imprimirComprovanteEstorno()" [disabled]="isImprimindoComprovanteEstorno"
                      class="px-2 py-1 rounded text-[11px] font-semibold text-white whitespace-nowrap flex-shrink-0"
                      style="background-color: #991b1b"
                      [style.opacity]="isImprimindoComprovanteEstorno ? 0.6 : 1"
                      [style.cursor]="isImprimindoComprovanteEstorno ? 'not-allowed' : 'pointer'">
                {{ isImprimindoComprovanteEstorno ? 'Gerando...' : 'Imprimir comprovante' }}
              </button>
              <button type="button" (click)="fecharComprovanteEstorno()"
                      class="px-2 py-1 rounded text-[11px] font-semibold" style="color: #991b1b">
                Fechar
              </button>
            </div>
          </div>
          <p *ngIf="comprovanteEstornoErro" class="mt-1 text-xs" style="color: #991b1b">{{ comprovanteEstornoErro }}</p>

          <div *ngIf="ultimoComprovanteTransferencia" class="mt-2 rounded-lg px-3 py-2 text-xs flex items-center justify-between gap-2 flex-wrap"
               style="background-color: #eef2ff; border: 1px solid #c7d2fe; color: #3730a3">
            <span>
              {{ brl(ultimoComprovanteTransferencia.valor) }} liberado para
              {{ ultimoComprovanteTransferencia.destinoNome }}.
            </span>
            <div class="flex items-center gap-2">
              <button type="button" (click)="imprimirComprovanteTransferencia()"
                      class="px-2 py-1 rounded text-[11px] font-semibold text-white whitespace-nowrap flex-shrink-0"
                      style="background-color: #3730a3">
                Imprimir comprovante
              </button>
              <button type="button" (click)="ultimoComprovanteTransferencia = null"
                      class="px-2 py-1 rounded text-[11px] font-semibold" style="color: #3730a3">
                Fechar
              </button>
            </div>
          </div>
          <p *ngIf="comprovanteTransferenciaErro" class="mt-1 text-xs" style="color: #991b1b">{{ comprovanteTransferenciaErro }}</p>
        </div>
    </div>
  </div>
</div>

<div *ngIf="estornoAlvo" class="fixed inset-0 z-50 flex items-center justify-center"
     style="background-color: rgba(0,0,0,0.5)">
  <div class="bg-white rounded-2xl shadow-xl overflow-hidden" style="width: 420px; max-width: 90vw">
    <div class="px-5 pt-5 pb-3">
      <div class="h-1 w-10 rounded-full mb-3" style="background-color: #991b1b"></div>
      <h2 class="text-base font-semibold" style="color: var(--tx)">Estornar adiantamento</h2>
      <p class="text-xs mt-0.5" style="color: var(--tx-2)">Devolucao de valor ja recebido do paciente.</p>
    </div>

    <div class="px-5 pb-5 space-y-3">
      <div class="rounded-lg px-3 py-3" style="background-color: #fef2f2; border: 1px solid #fecaca">
        <p class="text-[10px] font-semibold uppercase tracking-wide" style="color: #991b1b">Valor a devolver</p>
        <p class="text-2xl font-bold tabular-nums mt-0.5" style="color: #991b1b">
          {{ brl(estornoAlvo.vlAdiantamento) }}
        </p>
        <p class="text-sm font-semibold mt-1 break-words" style="color: var(--tx)">
          {{ paciente?.nmPessoaFisica }}
        </p>
      </div>

      <div class="rounded-lg px-3 py-2.5 text-xs space-y-1" style="background-color: var(--flua-rodape); border: 1px solid var(--flua-borda)">
        <div class="flex justify-between gap-3">
          <span style="color: var(--tx-2)">Adiantamento</span>
          <span class="font-semibold tabular-nums" style="color: var(--tx)">{{ estornoAlvo.nrAdiantamento }}</span>
        </div>
        <div class="flex justify-between gap-3">
          <span style="color: var(--tx-2)">Data</span>
          <span class="tabular-nums" style="color: var(--tx)">{{ estornoAlvo.dtAdiantamento | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
        <div class="flex justify-between gap-3">
          <span style="color: var(--tx-2)">Origem</span>
          <span style="color: var(--tx)">{{ origemDoAdiantamento(estornoAlvo) }}</span>
        </div>
        <div class="flex justify-between gap-3">
          <span style="color: var(--tx-2)">Saldo atual</span>
          <span class="font-semibold tabular-nums" style="color: var(--tx)">{{ brl(estornoAlvo.vlSaldo) }}</span>
        </div>
      </div>

      <p class="text-xs" style="color: var(--tx-2)">
        <span *ngIf="eDeEspecie(estornoAlvo)">
          O valor sai do caixa e o recebimento é cancelado. O estorno em espécie só é aceito no
          mesmo dia do recebimento.
        </span>
        <span *ngIf="!eDeEspecie(estornoAlvo)">
          A devolução é solicitada à operadora do cartão e pode levar alguns dias para aparecer
          na fatura do paciente.
        </span>
      </p>

      <div *ngIf="foiTransferido(estornoAlvo)" class="rounded-lg px-3 py-2.5 text-xs"
           style="background-color: #eef2ff; border: 1px solid #c7d2fe; color: #3730a3">
        Este saldo está liberado para
        <strong>{{ identificacao(estornoAlvo.nmPessoaAdiant, estornoAlvo.nrCpfPessoaAdiant) }}</strong>.
        Ao estornar, o valor volta para {{ paciente?.nmPessoaFisica }} e essa pessoa perde o crédito.
      </div>

      <p class="text-xs font-semibold" style="color: #991b1b">Esta ação não pode ser desfeita.</p>
      <div *ngIf="erroEstorno"
           class="rounded-lg px-3 py-2 text-xs"
           style="background-color: #fef2f2; border: 1px solid #fecaca; color: #991b1b">
        {{ erroEstorno }}
      </div>
    </div>

    <div class="px-5 py-4 flex justify-end gap-2" style="border-top: 1px solid var(--flua-borda)">
      <button (click)="fecharConfirmEstorno()"
              [disabled]="isEstornando"
              class="px-4 py-2 rounded-lg text-xs font-semibold"
              style="border: 1px solid var(--flua-borda); color: var(--tx-2)">
        Cancelar
      </button>
      <button (click)="confirmarEstorno()"
              [disabled]="isEstornando"
              class="px-4 py-2 rounded-lg text-xs font-semibold text-white flex items-center gap-1.5"
              [style.backgroundColor]="isEstornando ? '#D6CFC2' : '#991b1b'"
              [style.cursor]="isEstornando ? 'not-allowed' : 'pointer'">
        <div *ngIf="isEstornando" class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
        {{ isEstornando ? 'Estornando...' : 'Estornar' }}
      </button>
    </div>
  </div>
</div>

<div *ngIf="transferenciaAlvo" class="fixed inset-0 z-50 flex items-center justify-center"
     style="background-color: rgba(0,0,0,0.5)">
  <div class="bg-white rounded-2xl shadow-xl" style="width: 460px; max-width: 90vw">
    <div class="px-5 pt-5 pb-3">
      <div class="h-1 w-10 rounded-full mb-3" style="background-color: #3730a3"></div>
      <h2 class="text-base font-semibold" style="color: var(--tx)">Transferir saldo</h2>
      <p class="text-xs mt-0.5" style="color: var(--tx-2)">
        O pagamento continua no nome de {{ paciente?.nmPessoaFisica }}. Muda apenas quem pode usar o saldo.
      </p>
    </div>

    <div class="px-5 pb-5 space-y-3">
      <div class="rounded-lg px-3 py-3" style="background-color: #eef2ff; border: 1px solid #c7d2fe">
        <p class="text-[10px] font-semibold uppercase tracking-wide" style="color: #3730a3">Saldo a transferir</p>
        <p class="text-2xl font-bold tabular-nums mt-0.5" style="color: #3730a3">
          {{ brl(saldoExibido(transferenciaAlvo)) }}
        </p>
        <p class="text-xs mt-1" style="color: var(--tx-2)">
          Adiantamento {{ transferenciaAlvo.nrAdiantamento }} ·
          {{ transferenciaAlvo.dtAdiantamento | date:'dd/MM/yyyy HH:mm' }}
        </p>
      </div>

      <div>
        <label class="text-xs font-semibold mb-1.5 block" style="color: var(--tx)">Transferir para</label>
        <div class="relative">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="2" stroke="currentColor" class="campo-busca-icone size-4">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"/>
        </svg>
          <input type="text" [(ngModel)]="transferenciaTermo" (ngModelChange)="onTermoDestinoChange()"
                 [disabled]="isTransferindo || isAnexandoTermo"
                 placeholder="Nome ou CPF do destinatário"
                 class="campo-busca" />
          <div class="campo-busca-acao">
            <div *ngIf="isBuscandoDestino" class="animate-spin rounded-full h-4 w-4 border-b-2" style="border-color: var(--brand-primary)"></div>
          </div>
        </div>

        <div *ngIf="transferenciaResultados.length > 0"
             class="mt-1 rounded-lg overflow-hidden" style="border: 1px solid var(--flua-borda); max-height: 160px; overflow-y: auto">
          <button *ngFor="let p of transferenciaResultados" type="button" (click)="selecionarDestino(p)"
                  class="w-full text-left px-3 py-2 text-xs hover:bg-gray-50"
                  style="border-bottom: 1px solid #eef0f4; color: var(--tx)">
            <div class="font-semibold">{{ p.nmPessoaFisica }}</div>
            <div class="text-[11px]" style="color: var(--tx-2)">{{ p.nrCpf }}</div>
          </button>
        </div>

        <div *ngIf="transferenciaDestino" class="mt-2 rounded-lg px-3 py-2" style="background-color: var(--flua-rodape); border: 1px solid var(--flua-borda)">
          <p class="text-[10px] font-semibold uppercase tracking-wide" style="color: var(--tx-2)">Destinatário</p>
          <p class="text-sm font-semibold" style="color: var(--tx)">{{ transferenciaDestino.nmPessoaFisica }}</p>
          <p class="text-[11px]" style="color: var(--tx-2)">{{ transferenciaDestino.nrCpf }}</p>
        </div>
      </div>

      <div *ngIf="transferenciaDestino" class="rounded-lg px-3 py-3 space-y-2"
           style="background-color: var(--flua-rodape); border: 1px solid var(--flua-borda)">
        <p class="text-[10px] font-semibold uppercase tracking-wide" style="color: var(--tx-2)">
          Termo assinado
        </p>
        <p class="text-[11px]" style="color: var(--tx-2)">
          Imprima o termo, colha a assinatura, escaneie em PDF e anexe. Sem o termo anexado a
          transferência não é concluída.
        </p>

        <div class="flex items-center gap-2 flex-wrap">
          <button type="button" (click)="imprimirTermoTransferencia()"
                  class="px-2.5 py-1 rounded-lg text-[11px] font-semibold"
                  style="border: 1px solid #c7d2fe; background-color: #eef2ff; color: #3730a3">
            Imprimir termo
          </button>

          <input type="file" accept="application/pdf" (change)="onTermoSelecionado($event)"
                 [disabled]="isAnexandoTermo || isTransferindo"
                 class="text-[11px]" style="color: var(--tx-2); max-width: 190px" />

          <button type="button" (click)="anexarTermo()"
                  [disabled]="!termoArquivo || isAnexandoTermo || isTransferindo"
                  class="px-2.5 py-1 rounded-lg text-[11px] font-semibold text-white flex items-center gap-1.5"
                  [style.backgroundColor]="!termoArquivo || isAnexandoTermo ? '#D6CFC2' : '#3730a3'"
                  [style.cursor]="!termoArquivo || isAnexandoTermo ? 'not-allowed' : 'pointer'">
            <div *ngIf="isAnexandoTermo" class="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
            {{ isAnexandoTermo ? 'Anexando...' : 'Anexar termo' }}
          </button>
        </div>

        <p *ngIf="termoAnexado" class="text-[11px] font-semibold" style="color: #166534">
          Termo anexado.
        </p>
        <p *ngIf="erroTermo" class="text-[11px]" style="color: #991b1b">{{ erroTermo }}</p>
      </div>

      <p class="text-xs" style="color: var(--tx-2)">
        Só é possível transferir para quem tem {{ paciente?.nmPessoaFisica }} como responsável
        cadastrado. Se o vínculo não existir, a transferência é recusada.
      </p>

      <div *ngIf="erroTransferencia"
           class="rounded-lg px-3 py-2 text-xs"
           style="background-color: #fef2f2; border: 1px solid #fecaca; color: #991b1b">
        {{ erroTransferencia }}
      </div>
    </div>

    <div class="px-5 py-4 flex justify-end gap-2" style="border-top: 1px solid var(--flua-borda)">
      <button (click)="fecharTransferencia()"
              [disabled]="isTransferindo"
              class="px-4 py-2 rounded-lg text-xs font-semibold"
              style="border: 1px solid var(--flua-borda); color: var(--tx-2)">
        Cancelar
      </button>
      <button (click)="confirmarTransferencia()"
              [disabled]="isTransferindo || !transferenciaDestino || !termoAnexado"
              class="px-4 py-2 rounded-lg text-xs font-semibold text-white flex items-center gap-1.5"
              [style.backgroundColor]="isTransferindo || !transferenciaDestino || !termoAnexado ? '#D6CFC2' : '#3730a3'"
              [style.cursor]="isTransferindo || !transferenciaDestino || !termoAnexado ? 'not-allowed' : 'pointer'">
        <div *ngIf="isTransferindo" class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
        {{ isTransferindo ? 'Transferindo...' : 'Transferir' }}
      </button>
    </div>
  </div>
</div>

<app-responsavel-modal
  [aberto]="showModalResponsavel"
  [cdPessoaFisica]="paciente?.cdPessoaFisica ?? null"
  [cpfPaciente]="paciente?.nrCpf ?? null"
  (fechar)="showModalResponsavel = false"
  (carregado)="onResponsavelCarregado($event)"
  (salvo)="onResponsavelSalvo($event)">
</app-responsavel-modal>
